module.exports = __webpack_public_path__ + "assets/edit.bb2b1351.svg";